import Icon from '@/components/ui/AppIcon';

export default function MissionSection() {
  const values = [
  {
    id: 'value_1',
    icon: 'ShieldCheckIcon',
    title: 'Quality First',
    description: 'European manufacturing standards'
  },
  {
    id: 'value_2',
    icon: 'HeartIcon',
    title: 'Farmer Focused',
    description: 'Your success is our priority'
  }];


  return (
    <section className="py-section px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="reveal">
            <p className="text-primary font-bold uppercase tracking-wider text-sm mb-4">Our Mission</p>
            <h2 className="text-heading-2 md:text-[2.75rem] font-bold tracking-tight leading-tight text-foreground mb-6">
              "To empower farmers with performance-driven nutrition that transforms productivity."
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              At Bloom Animal Feeds, we understand the challenges poultry farmers face — rising feed costs, inconsistent quality, and unpredictable results.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              We bridge the gap between advanced European feed science and local farming needs by delivering reliable, performance-driven nutrition solutions.
            </p>

            {/* Mission Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-xl mb-8">
              <div className="aspect-[4/3] bg-gradient-to-br from-green-100 to-green-50">
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1c6bc3f27-1770040084525.png"
                  alt="Farmer working in modern poultry farm checking on healthy broiler chickens"
                  className="w-full h-full object-cover" />
                
              </div>
            </div>
          </div>

          {/* Right Values */}
          <div className="space-y-6 reveal" style={{ animationDelay: '0.2s' }}>
            {values.map((value) =>
            <div key={value.id} className="glass-card rounded-2xl p-8 hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={value.icon as any} size={28} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="text-heading-3 text-foreground mb-2">{value.title}</h3>
                    <p className="text-base text-muted-foreground">{value.description}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Additional Farm Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <div className="aspect-[4/3] bg-gradient-to-br from-green-100 to-green-50">
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_146d671e7-1766824099694.png"
                  alt="Brown layer hens in organized poultry farm with clean nesting boxes and fresh eggs"
                  className="w-full h-full object-cover" />
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}